import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import { LoadingBox } from "@components/LoadingBox";

export function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingBox minHeight="60vh" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/account" replace />;
  }

  return <Outlet />;
}
